import React from "react";
import axios from 'axios';
import CommonProjectViewSection from "./CommonProjectViewSection";
import { Link } from "react-router-dom";
import uuid from "react-uuid";
import CommonTrendingVideoGrid from "./CommonTrendingVideoGrid";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";

class TrendingContentSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            trendingContentDataList: [],
            shouldPlay: false,
            responseMessage: ''
        }
    }
    handleEnterViewport = () => {
        this.setState({
            shouldPlay: true,
        })
    };
    handleExitViewport = () => {
        this.setState({
            shouldPlay: false
        })
    };

    componentDidMount() {
        this.getAllTrendingContentData();
    };

    getAllTrendingContentData = () => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/backend/pre/login/trendingContent/getPublicList?page=${this.state.page}&size=${this.state.size}&loginType=PRE_LOGIN`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        }).then((response) => {
            if (response && response.data && response.data.message === "Success!") {
                this.setState({
                    trendingContentDataList: response?.data?.body?.content,
                    responseMessage: response.data?.message
                })
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    getSkeletonData = () => {
        return(
            <>             
                <SkeletonTheme>
                    <div className='row'>

                        <div className='col-lg-6'>
                            <div className='lndSolVideoBlk skeletonBlk' style={{border: 'none'}}>
                                <a>
                                    <Skeleton height={"100%"} width={"100%"}/>
                                    <span className="btnYoutube"><Skeleton circle={true} height={60} width={60}/></span>
                                </a>
                            </div> 
                        </div>

                        <div className='col-lg-6'>

                            <div className='row'>
                                {Array(2).fill().map((item,index) => {
                                    return (
                                        <div className='col-lg-6' key={index}>
                                            <div className='lndSolVideoBlk smallVid skeletonBlk' style={{border: 'none'}}>
                                                <a>
                                                    <Skeleton height={"100%"} width={"100%"}/>
                                                    <span className="btnYoutube"><Skeleton circle={true} height={60} width={60}/></span>
                                                </a>
                                            </div> 
                                        </div>
                                    )
                                })}
                            </div>

                                    <div className={'lndForNatureHashBlk'}>
                                        {Array(9).fill().map((item,index) => {
                                            return <SkeletonTheme><Skeleton height={36} width={`80%`}/></SkeletonTheme>
                                        })}
                                    </div>
                                    <div class="text-center mt-3 mb-3">
                                        <Skeleton height={36} width={`80%`}/>
                                    </div>
                        </div>
                    </div>
                </SkeletonTheme>

                <div className='row'>
                    {Array(4).fill().map((item, index)=>{
                        return(                            
                                <div className="col-md-3">
                                    <SkeletonTheme>
                                        <div className="lndprojeventlist">
                                            <div className="lndprojeventlistinn">
                                                <figure>
                                                    <Skeleton height={166} width={"100%"}/>
                                                </figure>
                                                <div className="lndprojeventdesc">
                                                    <Skeleton height={36} width={`100%`}/>                                                            
                                                </div>
                                            </div>
                                        </div>      
                                    </SkeletonTheme>                               
                                </div>
                            )})}
                </div>
             </>
        )

    }

    render() {
        const { trendingContentDataList } = this.state;

        return (
            <section className='lndForNatureWrap sectionLndAll'>
                <div className='title'>
                    <h2>Do More. Be More. For People and Environment</h2>
                    <h3>What's Trending on <img src="https://cdn.dscovr.com/images/logoWeNaturalists.svg" width="212" alt="WeNaturalists" style={{ verticalAlign: 'middle' }}></img></h3>
                </div>
                {this.state.responseMessage === 'Success!' ? 
                <>
                    {trendingContentDataList && trendingContentDataList.length > 0 && trendingContentDataList?.slice(0, 1).map((item, inx) => {
                        return (
                            <>
                                <div className='row'>
                                    {item?.trendingVideos && item?.trendingVideos.length > 0 &&
                                        <CommonTrendingVideoGrid trendingVideosData={item?.trendingVideos[0]} />
                                    }
                                    <div className='col-lg-6'>
                                        <div className='row'>
                                            {item?.trendingVideos?.slice(0, 3).map((trendingVideo, index) => {
                                                return (index !== 0 && <CommonTrendingVideoGrid trendingVideosData={trendingVideo} type={"SMALL"} />)
                                            })}
                                        </div>

                                        {item?.popularTags && item?.popularTags.length > 0 &&
                                            <>
                                                <div className={item?.trendingVideos && item?.trendingVideos.length > 0 ? 'lndForNatureHashBlk' : 'lndForNatureHashBlk nonVid'}>
                                                    {item?.popularTags.map((popularTag, inx) => {
                                                        return <Link className="" to={`/explore-hashtag/${popularTag}`}><span>#{popularTag}</span></Link>
                                                    })}
                                                </div>
                                                <div class="text-center mt-3 mb-3">
                                                    <Link to={'/explore-hashtag'} class="btn morebtnsm">View All</Link>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>

                                {item?.trendingArticles && item?.trendingArticles.length > 0 && <div className='lndSolHighlightBlk'>
                                    <div className='row'>
                                        {item?.trendingArticles.slice(0, 4).map((trendingArticle, inx) => {
                                            return <CommonProjectViewSection item={trendingArticle} key={inx} sectionType={"TRENDING_CONTENT"} />
                                        })}
                                    </div>
                                </div>}
                            </>
                        )
                    })}

                </>
                :
                
                (this.getSkeletonData())
                }

                
            </section>
        );
    }
}

export default TrendingContentSection;